<script lang="ts" setup>
import Modal from '@/components/modal/Modal.vue';
import TextButton from '@/components/input/Btn/TextButton.vue';

// props
const props = withDefaults(
  defineProps<{
    modalState?: boolean;
    titleText: string | HTMLElement;
    confirmButtonText: string;
    denyButtonText: string;
    contentText?: string;
  }>(),
  {
    modalState: false,
    contentText: undefined,
  }
);

// emits
const emits = defineEmits<{
  (e: 'closeModal'): void;
  (e: 'confirm'): void;
}>();
</script>

<template>
  <Modal
    class="confirm-modal-container"
    :modal-size="550"
    :stretch-container="true"
    :scroll-off="true"
    :padding="'24px 16px'"
    :modal-state="modalState"
    :border-radius="'16px'"
    @outside-click="emits('closeModal')"
  >
    <div class="confirm-modal-content">
      <div class="confirm-modal-content__header">
        <span>{{ titleText }}</span>
      </div>

      <div v-if="contentText" class="confirm-modal-content__main-content">
        {{ contentText }}
      </div>

      <div class="confirm-modal-content__footer footer">
        <TextButton
          :button-style="'btn-cancel'"
          :size="'btn-md'"
          :on-click="() => emits('closeModal')"
          class="footer__button footer__button--cancel"
        >
          {{ denyButtonText }}
        </TextButton>
        <TextButton
          :button-style="'btn-primary'"
          :size="'btn-md'"
          :on-click="() => emits('confirm')"
          class="footer__button footer__button--confirm"
        >
          {{ confirmButtonText }}
        </TextButton>
      </div>
    </div>
  </Modal>
</template>

<style lang="scss" scoped>
.confirm-modal-content {
  height: 100%;
  display: grid;
  grid-template-rows: auto 1fr auto;
  gap: 24px;
  justify-items: center;
  color: $textDefault;

  &__header {
    font-size: 22px;
    font-weight: 700;
    line-height: 28.6px;
  }

  &__main-content {
    white-space: pre-line;
    text-align: center;
    font-size: 14px;
    line-height: 18.2px;
    font-weight: 400;
  }

  &__footer {
    display: grid;
    grid-template-columns: repeat(2, fit-content(50%));
    padding-top: 16px;
  }
}

.footer {
  display: grid;
  grid-template-columns: repeat(2, auto);
  justify-self: center;
  gap: 10px;

  &__button {
    width: 160px;
    height: 40px;
    font-size: 16px;
    line-height: 16px;
    font-weight: 700;

    &--cancel {
      padding: 6px 32px 6px 32px;
    }
    &--confirm {
      padding: 6px 56px 6px 56px;
    }
  }
}
</style>
